import { useState, useEffect } from 'react';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Drawer, Divider, IconButton } from '@mui/material';
// hooks
import useResponsive from 'src/hooks/useResponsive';
// components
import Iconify from 'src/minimals/components/Iconify';
//
// import ChatRoomAttachment from './ChatRoomAttachment';
import ChatRoomOneParticipant from './ChatRoomOneParticipant';
import ChatRoomGroupParticipant from './ChatRoomGroupParticipant';
import Scrollbar from 'src/minimals/Scrollbar';

const SIDEBAR_WIDTH = 280;

export default function ChatRoom({ conversation, participants }) {
  const theme = useTheme();
  const [openSidebar, setOpenSidebar] = useState(true);
  const [showInfo, setShowInfo] = useState(true);
  const [selectUser, setSelectUser] = useState(null);
  // const [showAttachment, setShowAttachment] = useState(true);
  const [showParticipants, setShowParticipants] = useState(true);
  const isDesktop = useResponsive('up', 'lg');
  const isGroup = conversation.type === 'GROUP';

  useEffect(() => {
    if (!isDesktop) {
      return handleCloseSidebar();
    }
    return handleOpenSidebar();
  }, [isDesktop]);

  const handleOpenSidebar = () => {
    setOpenSidebar(true);
  };

  const handleCloseSidebar = () => {
    setOpenSidebar(false);
  };

  const handleToggleSidebar = () => {
    setOpenSidebar((prev) => !prev);
  };

  const renderContent = (
    <Scrollbar>
      {isGroup ? (
        <ChatRoomGroupParticipant
          selectUserId={selectUser}
          participants={participants}
          isCollapse={showParticipants}
          onShowPopupUserInfo={(participantId) => setSelectUser(participantId)}
          onCollapse={() => setShowParticipants((prev) => !prev)}
        />
      ) : (
        <div>
          <ChatRoomOneParticipant
            participants={participants}
            isCollapse={showInfo}
            onCollapse={() => setShowInfo((prev) => !prev)}
          />
        </div>
      )}
      <Divider />
      {/* <ChatRoomAttachment
        conversation={conversation}
        isCollapse={showAttachment}
        onCollapse={() => setShowAttachment((prev) => !prev)}
      /> */}
    </Scrollbar>
  );

  return (
    <>
      <ToggleButtonStyle
        onClick={handleToggleSidebar}
        sx={{
          ...(openSidebar && isDesktop && { right: SIDEBAR_WIDTH }),
          zIndex: 9000,
        }}
      >
        <Iconify
          width={16}
          height={16}
          icon={
            openSidebar
              ? 'eva:arrow-ios-forward-fill'
              : 'eva:arrow-ios-back-fill'
          }
        />
      </ToggleButtonStyle>
      <Drawer
        open={openSidebar}
        anchor="right"
        variant="persistent"
        sx={{
          height: 1,
          width: SIDEBAR_WIDTH,
          transition: theme.transitions.create('width'),
          ...(!openSidebar && { width: '0px' }),
          ...(!isDesktop && {
            height: '100%',
            transition: theme.transitions.create('width'),
            ...(!openSidebar && { width: '0px' }),
          }),
          '& .MuiDrawer-paper': {
            position: 'static',
            width: SIDEBAR_WIDTH,
            ...(!isDesktop && {
              width: '100%',
              position: 'absolute',
              transform: 'none !important',
              visibility: 'visible !important',
              ...(!openSidebar && { width: '0px' }),
            }),
          },
        }}
      >
        {renderContent}
      </Drawer>
    </>
  );
}

const ToggleButtonStyle = styled((props) => (
  <IconButton disableRipple {...props} />
))(({ theme }) => ({
  right: 0,
  zIndex: 9,
  width: 32,
  height: 32,
  position: 'absolute',
  top: theme.spacing(1),
  boxShadow: theme.customShadows.z8,
  backgroundColor: theme.palette.background.paper,
  border: `solid 1px ${theme.palette.divider}`,
  borderRight: 0,
  borderRadius: `12px 0 0 12px`,
  transition: theme.transitions.create('all'),
  '&:hover': {
    backgroundColor: theme.palette.background.neutral,
  },
}));
